/*
 * @Author: yinbing.liu
 * @Date: 2023-09-17 16:23:28
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-07-23 14:32:25
 * @FilePath: /fushigi/src/main.ts
 * @Description:
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from '@/App.vue'
import router from '@/router'
import '@/router/permission'
import 'virtual:uno.css'
import 'ant-design-vue/dist/reset.css'
import 'vueperslides/dist/vueperslides.css'
import '@/styles/public.less'
import 'virtual:svg-icons-register'
import { SvgIcon } from '@/components/SvgIcon'

const app = createApp(App)
const pinia = createPinia()
// pinia 刷新缓存不丢失
pinia.use(piniaPluginPersistedstate)
app.component('SvgIcon', SvgIcon)
app.use(pinia).use(router).mount('#app')
